window.addEventListener('error', (e: ErrorEvent) => {
  // Surface synchronous render/runtime errors to the console
  // so they don't get swallowed by the browser's default handler
  // and result in a white screen with no clues.
  // eslint-disable-next-line no-console
  console.error('GlobalError', e.error || e.message);
});

window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  // Surface async errors (promises) to the console for quick triage
  // eslint-disable-next-line no-console
  console.error('UnhandledRejection', e.reason);
});

export {};
